document.addEventListener("DOMContentLoaded", function () {
  /* ---------- header ---------- */
  const header = document.getElementById("dz-header");
  const onScroll = () => {
    if (!header) return;
    if (window.scrollY > 50) {
      header.style.background = "rgba(10,10,10,0.72)";
      header.style.backdropFilter = "blur(16px)";
      header.style.webkitBackdropFilter = "blur(16px)";
      header.style.borderBottomColor = "#1c1c22";
    } else {
      header.style.background = "transparent";
      header.style.backdropFilter = "none";
      header.style.webkitBackdropFilter = "none";
      header.style.borderBottomColor = "transparent";
    }
  };
  onScroll();
  window.addEventListener("scroll", onScroll, { passive: true });

  /* ---------- mobile menu ---------- */
  const burger = document.getElementById("dz-burger");
  const menu = document.getElementById("dz-mobile");
  let mobileOpen = false;

  const closeMobile = () => {
    if (!menu) return;
    mobileOpen = false;
    menu.style.opacity = "0";
    menu.style.pointerEvents = "none";
    if (burger) {
      const spans = burger.querySelectorAll("span");
      spans[0].style.transform = "none";
      spans[1].style.opacity = "1";
      spans[2].style.transform = "none";
    }
  };

  if (burger && menu) {
    burger.addEventListener("click", () => {
      mobileOpen = !mobileOpen;
      const spans = burger.querySelectorAll("span");
      if (mobileOpen) {
        menu.style.opacity = "1";
        menu.style.pointerEvents = "auto";
        spans[0].style.transform = "translateY(7px) rotate(45deg)";
        spans[1].style.opacity = "0";
        spans[2].style.transform = "translateY(-7px) rotate(-45deg)";
      } else {
        closeMobile();
      }
    });

    // Close on link click
    const mLinks = menu.querySelectorAll("a");
    mLinks.forEach((l) => {
      l.addEventListener("click", () => {
        closeMobile();
      });
    });
  }

  // responsive burger toggle via matchMedia
  const mq = window.matchMedia("(max-width: 860px)");
  const apply = () => {
    const nav = document.getElementById("dz-desknav");
    if (mq.matches) {
      if (burger) burger.style.display = "flex";
      if (nav) nav.style.display = "none";
    } else {
      if (burger) burger.style.display = "none";
      if (nav) nav.style.display = "flex";
      closeMobile();
    }
  };
  apply();
  mq.addEventListener("change", apply);

  /* ---------- sticky CTA bar ---------- */
  const bar = document.getElementById("dz-stickycta");
  const footer = document.querySelector(".footer"); // Fallback for Shopify default footer class
  if (bar) {
    const onScrollCta = () => {
      const y = window.scrollY;
      let nearFooter = false;
      if (footer) {
        nearFooter = footer.getBoundingClientRect().top < window.innerHeight * 0.9;
      }
      
      const show = y > window.innerHeight * 0.9 && !nearFooter;
      const mobile = window.innerWidth <= 600;
      const hidden = mobile ? "translateY(140%)" : "translate(-50%,140%)";
      const shown = mobile ? "translateY(0)" : "translate(-50%,0)";
      bar.style.transform = show ? shown : hidden;
    };
    onScrollCta();
    window.addEventListener("scroll", onScrollCta, { passive: true });
  }
});
